import useController from "@hooks/useController"

export default function useSalonAcceptanceGalleryController(): General.Controllers.SalonAcceptanceGallery {
    const controller = useController(`/api/salons`)

    const show = (slug: string, sectionId: string | undefined) => controller.get(`${slug}/acceptances/gallery${sectionId ? `/${sectionId}` : ''}`)

    return { show }
}